(function () {
  const ROTATE_MS = 5000;
  const SWITCH_MS = 360;
  const STACK_SIZE = 3;
  const MAX_QUOTE_CHARS = 92;
  const SCRAPE_MAX_MS = 15000;
  const SCRAPE_INTERVAL_MS = 1000;

  const FALLBACK_REVIEWS = [
    { name: 'Josephine', body: 'Alles super, sieht sehr schön an der Wand aus.' },
    { name: 'Carmen', body: 'Alles bestens. Sehr netter Kontakt und die Bilder sind wirklich sehr schön.' },
    { name: 'Dominik', body: 'Top. Super Qualität. Sehr zu empfehlen.' },
    { name: 'Sascha', body: 'Superschönes, hochwertig verarbeitetes Moosbild. Schneller Versand.' },
    { name: 'Michael', body: 'Sieht in echt noch besser aus als auf den Fotos. Steht jetzt am Empfang in unserer Praxis.' },
  ];

  const AVATAR_COLORS = ['#dce6d4', '#d9e2d0', '#e8eddf', '#d5e0ce', '#cdd9c4'];
  const OPEN_QUOTE = '\u201E';
  const CLOSE_QUOTE = '\u201C';
  const instances = new WeakMap();

  function firstName(fullName) {
    if (!fullName) return 'Kunde';
    return fullName.trim().split(/\s+/)[0];
  }

  function initial(name) {
    return (firstName(name).charAt(0) || 'K').toUpperCase();
  }

  function truncateQuote(text, max = MAX_QUOTE_CHARS) {
    const clean = (text || '').replace(/\s+/g, ' ').trim();
    if (clean.length <= max) return clean;

    const slice = clean.slice(0, max);
    const lastSpace = slice.lastIndexOf(' ');
    const cut = lastSpace > max * 0.55 ? slice.slice(0, lastSpace) : slice.trimEnd();
    return `${cut}\u2026`;
  }

  function reviewsFingerprint(list) {
    return list.map((review) => `${review.name}|${review.body}`).join('\u0001');
  }

  function normalizeReview(name, body) {
    const cleanName = firstName(name);
    const cleanBody = (body || '').replace(/\s+/g, ' ').trim();
    if (!cleanName || cleanBody.length < 8) return null;
    return { name: cleanName, body: cleanBody };
  }

  function scrapeJudgeMeReviews() {
    const nodes = document.querySelectorAll(
      '.jdgm-rev-widg .jdgm-rev, #judgeme_product_reviews .jdgm-rev, .jdgm-all-reviews__body .jdgm-rev'
    );
    const reviews = [];
    const seen = new Set();

    nodes.forEach((node) => {
      const ratingEl = node.querySelector('.jdgm-rev__rating');
      const rating = parseFloat(
        node.getAttribute('data-score') || ratingEl?.getAttribute('data-score') || ratingEl?.title || '5'
      );
      if (!Number.isNaN(rating) && rating < 4) return;

      const author =
        node.querySelector('.jdgm-rev__author')?.textContent ||
        node.querySelector('.jdgm-rev__buyer-name')?.textContent ||
        '';
      const body =
        node.querySelector('.jdgm-rev__body')?.textContent ||
        node.querySelector('.jdgm-rev__content')?.textContent ||
        '';

      const review = normalizeReview(author, body);
      if (!review) return;

      const key = `${review.name}|${review.body}`;
      if (seen.has(key)) return;
      seen.add(key);
      reviews.push(review);
    });

    return reviews.length >= 2 ? reviews : null;
  }

  function destroyRotator(root) {
    const state = instances.get(root);
    if (!state) return;

    window.clearTimeout(state.rotateTimer);
    window.clearTimeout(state.switchTimer);
    window.clearInterval(state.scrapeTimer);
    state.observer?.disconnect();
    if (state.onVisibility) {
      document.removeEventListener('visibilitychange', state.onVisibility);
    }
    instances.delete(root);
    root.removeAttribute('data-moos-rotator-ready');
  }

  function initRotator(root) {
    destroyRotator(root);

    const stackEl = root.querySelector('[data-avatar-stack]');
    const nameEl = root.querySelector('[data-review-name]');
    const quoteEl = root.querySelector('[data-review-quote]');

    if (!stackEl || !nameEl || !quoteEl) return;

    root.dataset.moosRotatorReady = 'true';

    const state = {
      reviews: [...FALLBACK_REVIEWS],
      index: 0,
      fingerprint: reviewsFingerprint(FALLBACK_REVIEWS),
      rotateTimer: null,
      switchTimer: null,
      scrapeTimer: null,
      observer: null,
      animating: false,
      paused: false,
    };

    instances.set(root, state);

    function reviewAt(offset) {
      const count = state.reviews.length;
      return state.reviews[((state.index + offset) % count + count) % count];
    }

    function createAvatar(review, position, logicalIndex) {
      const item = document.createElement('div');
      item.className = 'moos-review-rotator__avatar';
      if (position === 0) item.classList.add('is-active');
      item.style.setProperty('--avatar-tone', AVATAR_COLORS[logicalIndex % AVATAR_COLORS.length]);
      item.innerHTML = `<span class="moos-review-rotator__avatar-initial">${initial(review.name)}</span>`;
      return item;
    }

    function buildStack() {
      stackEl.innerHTML = '';
      const visible = Math.min(STACK_SIZE, state.reviews.length);
      for (let i = 0; i < visible; i += 1) {
        const logicalIndex = (state.index + i) % state.reviews.length;
        stackEl.appendChild(createAvatar(reviewAt(i), i, logicalIndex));
      }
    }

    function updateQuote(review) {
      const displayBody = truncateQuote(review.body);
      nameEl.textContent = `\u2014 ${review.name}`;
      quoteEl.textContent = OPEN_QUOTE + displayBody + CLOSE_QUOTE;

      if (review.body.length > displayBody.length) {
        quoteEl.setAttribute('title', review.body);
      } else {
        quoteEl.removeAttribute('title');
      }
    }

    function renderCurrent(animate) {
      const count = state.reviews.length;
      if (count < 1) return;

      if (animate && count > 1) {
        state.animating = true;
        root.classList.add('is-switching');

        window.clearTimeout(state.switchTimer);
        state.switchTimer = window.setTimeout(() => {
          buildStack();
          updateQuote(state.reviews[state.index]);
          root.classList.remove('is-switching');
          state.animating = false;
        }, SWITCH_MS);
        return;
      }

      buildStack();
      updateQuote(state.reviews[state.index]);
    }

    function showNext() {
      if (state.animating || state.paused || state.reviews.length < 2) return;

      state.index = (state.index + 1) % state.reviews.length;
      renderCurrent(true);
      scheduleNext();
    }

    function scheduleNext() {
      window.clearTimeout(state.rotateTimer);
      if (state.reviews.length < 2 || state.paused) return;

      state.rotateTimer = window.setTimeout(() => {
        showNext();
      }, ROTATE_MS);
    }

    function setReviews(nextReviews, resetIndex) {
      if (!nextReviews || nextReviews.length < 2) return;

      const fingerprint = reviewsFingerprint(nextReviews);
      if (fingerprint === state.fingerprint) return;

      const previousIndex = state.index;
      state.reviews = nextReviews;
      state.fingerprint = fingerprint;

      if (resetIndex) {
        state.index = 0;
      } else {
        state.index = previousIndex % state.reviews.length;
      }

      renderCurrent(false);
      scheduleNext();
    }

    renderCurrent(false);
    scheduleNext();

    state.onVisibility = () => {
      if (document.hidden) {
        window.clearTimeout(state.rotateTimer);
      } else {
        scheduleNext();
      }
    };
    document.addEventListener('visibilitychange', state.onVisibility);

    const started = Date.now();
    let scrapeApplied = false;

    function tryScrape() {
      const scraped = scrapeJudgeMeReviews();
      if (!scraped) return false;

      setReviews(scraped, !scrapeApplied);
      scrapeApplied = true;
      return true;
    }

    if (!tryScrape()) {
      state.scrapeTimer = window.setInterval(() => {
        if (tryScrape() || Date.now() - started > SCRAPE_MAX_MS) {
          window.clearInterval(state.scrapeTimer);
          state.scrapeTimer = null;
        }
      }, SCRAPE_INTERVAL_MS);
    }

    const widgetRoot = document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews, .jdgm-all-reviews__body');
    if (widgetRoot && typeof MutationObserver !== 'undefined') {
      let scrapeTimeout = null;
      state.observer = new MutationObserver(() => {
        window.clearTimeout(scrapeTimeout);
        scrapeTimeout = window.setTimeout(() => {
          tryScrape();
        }, 400);
      });
      state.observer.observe(widgetRoot, { childList: true, subtree: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-moos-review-rotator]').forEach((root) => {
      initRotator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', boot);
})();
